// extracted by mini-css-extract-plugin
export var carouselContainer = "styles-module--carouselContainer--71675";
export var carouselContent = "styles-module--carouselContent--5ac50";
export var desktop = "1340px";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var paginationContainer = "styles-module--paginationContainer--17464";
export var paginationControls = "styles-module--paginationControls--13de5";
export var slide = "styles-module--slide--00ab8";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";